export default __webpack_public_path__ + "static/media/blue-circle.302d8025.svg";